import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface RemovalRequestAdminDto {
  id: string;
  fornecedor?: { id: string; nome: string };
  requesterEmail: string;
  reason: string;
  description?: string;
  status: string;
  requestedAt: string;
  requesterIpAddress?: string;
  adminNotes?: string;
  processedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class LgpdService {
  constructor(private api: ApiService) {}

  list(status?: string, page = 1, pageSize = 20): Observable<{ data: RemovalRequestAdminDto[]; meta: any }> {
    const params: any = { page, pageSize };
    if (status) params.status = status;
    return this.api.get('/admin/lgpd/removal-requests', params) as Observable<any>;
  }

  approve(id: string, adminNotes?: string): Observable<any> {
    return this.api.post(`/admin/lgpd/removal-requests/${id}/approve`, { adminNotes });
  }

  reject(id: string, adminNotes?: string): Observable<any> {
    return this.api.post(`/admin/lgpd/removal-requests/${id}/reject`, { adminNotes });
  }
}
